module.exports = __webpack_public_path__ + "img/section_icon_3.9169a361.svg";